import React, { useState, useMemo, useRef, useEffect } from 'react';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircleIcon from '@mui/icons-material/Circle';
import './ListView.scss';
import { useDispatch } from 'react-redux';
import { openBookProfile } from '../../../../slices/navigationSlice';

const BATCH_SIZE = 25;

export default function ListView({ books = [], onBookSelect }) {
    const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
    const sentinelRef = useRef(null);

    useEffect(() => {
        setVisibleCount(BATCH_SIZE);
    }, [books]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisibleCount((prev) => Math.min(prev + BATCH_SIZE, books.length));
                }
            },
            { threshold: 0.1, rootMargin: '200px'}
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => observer.disconnect();
    }, [books.length]);

    const visibleBooks = books.slice(0, visibleCount);

    const dispatch = useDispatch();
    return(

            <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                    width: '100%',
                    maxHeight: 'none',
                    overflowX: 'auto',
                    overflowY: 'visible',
                    borderRadius: 0,
                    boxShadow: 'none',
                    padding: 0,
                    fontFamily: "'Poppins', sans-serif"
                }}
            >
                <Table aria-label="books table" sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Cover</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Book Title</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Author</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Genre</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Availability</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, fontSize: '23px', backgroundColor: '#ececec'}}>Published</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {books.map((row) => {
                            const isAvailable = row.isAvailable === true;
                            return (
                                <TableRow key={row.id} hover onClick={() => onBookSelect(row)} sx={{ height: 60, cursor: 'pointer' }}>
                                    <TableCell align='center'>
                                        {row.cover ? (
                                            <img
                                            src={row.cover} //the ".cover" field is not currently being provided by the Salesforce API. it will also need to be changed to the correct varible
                                            alt={row.title}
                                            loading='lazy'
                                            decoding='async'
                                            style={{
                                                width: '80px',
                                                height: '95px',
                                                objectFit: 'cover',
                                                borderRadius: '4px'
                                                }}
                                            />
                                            ) : null}
                                    </TableCell>
                                    <TableCell align="center" sx={{fontSize: '18px', width: '400px'}}>{row.title}</TableCell>

                                    <TableCell align="center" sx={{fontSize: '18px'}}>{row.author}</TableCell>

                                    <TableCell align="center" sx={{fontSize: '18px'}}>{row.genre}</TableCell>

                                    <TableCell align="center" sx={{fontSize: '18px'}}>
                                        <span
                                        style={{
                                            color: isAvailable ? '#398e34' : '#d14e21',
                                            backgroundColor: isAvailable ? '#d3f0d4' : '#f4f4f4',
                                            padding: '4px 10px',
                                            borderRadius: '4px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontWeight: 600,
                                        }}
                                        >
                                        {isAvailable && <CircleIcon sx={{ fontSize: '14px' }} />}
                                        {isAvailable ? 'Available' : 'Checked Out'}
                                        </span>
                                    </TableCell>

                                    <TableCell align="center" sx={{fontSize: '18px'}}>{row.Published}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                {visibleCount < books.length && (
                    <div ref={sentinelRef} style={{ height: '20px', visibility: 'hidden' }} />
                )}
            </TableContainer>
    );
};